export default __webpack_public_path__ + "static/home-full-photo-eeee4651e3196b975f879e1fedfd499a.jpg";